// Third-party
import React from 'react';
import { Typography } from '@capintel/component-lib/typography';

import { ALLOWED_HTML_TAGS } from '../i18n/FormattedMessageV2';

type Props = {
  title?: string;
  body?: string;
  children: JSX.Element;
};

const ActionBox = ({ title, body, children, ...rest }: Props) => (
  <div className="action-box d-flex align-items-center" {...rest}>
    <div className="action-box-text flex-fill">
      {title && (
        <Typography variant="headerMd" as="h1">
          {title}
        </Typography>
      )}

      {body && (
        <Typography as={ALLOWED_HTML_TAGS.H2} color="secondary" variant="bodyMdRegular">
          {body}
        </Typography>
      )}
    </div>

    {children}
  </div>
);

export default ActionBox;
